<template>
  <button
    class="disabled:opacity-50 text-primary whitespace-nowrap"
    :class="{
      'cursor-pointer': !disabled,
      'cursor-default': disabled,
    }"
    v-tippy
    :content="title"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <font-awesome-icon
      :class="['fa-3x fill-current', textSizeClass, iconClasses, {
        'text-gray-500': disabled,
        'hover:text-dvbrandhoveron hover:underline': !disabled,
      }]"
      :icon="icon"
      :size="size"
    />
  </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    iconClasses: {
      type: [String, Array, Object],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "1x",
    },
  },
  computed: {
    textSizeClass() {
      const sizeMap = {
        'xs': 'text-xs',
        'sm': 'text-sm', 
        '1x': 'text-lg',
        'lg': 'text-xl',
        '2x': 'text-2xl'
      };
      return sizeMap[this.size] || 'text-lg';
    },
  }
}
</script>

<style lang="scss" scoped>

</style>